import { Shape } from 'diagram-js/lib/model';
import { constants } from '@ispm-client/modules/bpmn-modeler/constants/constants';

export class ShapeFocus {

  constructor(private canvas) { }

  setFocusOnShapeLeftCenter(element: Shape) {
    this.focusOnCoordinates(this.getXAlignedToLeft(element, constants.NEIGHBORHOOD_FOCUS_OFFSET_X), this.getYAlignedToCenter(element));
  }

  setFocusOnShapeRightCenter(element: Shape) {
    this.focusOnCoordinates(this.getXAlignedToRight(element, constants.NEIGHBORHOOD_FOCUS_OFFSET_X), this.getYAlignedToCenter(element));
  }

  setFocusOnShapeTopCenter(element: Shape) {
    this.focusOnCoordinates(this.getXAlignedToCenter(element), this.getYAlignedToTop(element, constants.NEIGHBORHOOD_FOCUS_OFFSET_Y));
  }

  setDefaultFocusOnShape(element: Shape) {
    this.focusOnCoordinates(this.getXAlignedToLeft(element, constants.FILTERS_RIGHT_PANEL_WIDTH), this.getYAlignedToCenter(element));
  }

  setDefaultFocusOnShapeWithRightShift(element: Shape, shiftData: any) {
    if (!!shiftData.shift) {
      this.focusOnCoordinates(shiftData.shift === 'fromRight' ? this.getXAlignedToRight(element, shiftData.X, true) : this.getXAlignedToRightWithOffset(element, shiftData.X,true),
        shiftData.Y === 0 ? this.getYAlignedToCenter(element) : this.getYAlignedToTop(element, shiftData.Y));
    } else {
      this.setFocusOnShapeXYCenter(element);
    }
  }

  setFocusOnShapeXYCenter(element: Shape) {
    this.focusOnCoordinates(this.getXAlignedToCenter(element), this.getYAlignedToCenter(element));
  }

  setInitialFocus(verticalLayout: boolean = false) {
    if(verticalLayout) {
      const currentViewbox = this.canvas.viewbox();
      this.canvas.viewbox({
        x: currentViewbox.x - (currentViewbox.width/3 - constants.NODE_DIMENSIONS.width/4),
        y: currentViewbox.y + constants.DEFAULT_VERTICAL_INITIAL_POSITION_OFFSET.y,
        width: currentViewbox.width,
        height: currentViewbox.height
      });
    }
  }


  private focusOnCoordinates(x: number, y: number) {
    const currentViewbox = this.canvas.viewbox();
    this.canvas.viewbox({
      x,
      y,
      width: currentViewbox.width,
      height: currentViewbox.height
    });
  }

  private getXAlignedToRight(element: Shape, offset: number, useScale:boolean = false) {
    const currentViewbox = this.canvas.viewbox();
    return element.x - (currentViewbox.width - element.width) + (useScale ? offset/currentViewbox.scale: offset);
  }

  private getXAlignedToRightWithOffset(element: Shape, offset: number, useScale:boolean = false) {
    const currentViewbox = this.canvas.viewbox();
    return element.x - (currentViewbox.width - element.width) + (useScale ? (offset/currentViewbox.scale - element.width):(offset - element.width));
  }

  private getXAlignedToLeft(element: Shape, offset: number) {
    return element.x - offset;
  }

  private getXAlignedToCenter(element: Shape) {
    const currentViewbox = this.canvas.viewbox();
    return element.x - (currentViewbox.width - element.width) / 2;
  }

  private getYAlignedToTop(element: Shape, offset: number) {
    return element.y - offset;
  }

  private getYAlignedToCenter(element: Shape, offset?: number) {
    const currentViewbox = this.canvas.viewbox();
    return element.y - (!!offset ? offset : 0) - (currentViewbox.height - element.height) / 2;
  }

}










